import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {InsolesModelModel} from "./insolesModel.model";
import {LovValueSummaryConverter} from "../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {InsolesModelSummaryConverter} from "./insolesModelSummary.converter";
import {InsoleModelGabaritShoeSizeSummaryConverter} from "./gabarit/insoleModelGabaritShoeSizeSummary.converter";
@Injectable({
    providedIn: 'root'
})
export class InsolesModelConverter extends HttpModelConverter<InsolesModelModel> {

    constructor(private summaryConverter: InsolesModelSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private insoleModelGabaritShoeSizeSummaryConverter: InsoleModelGabaritShoeSizeSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesModelModel {
        return new InsolesModelModel();
    }

    protected enrichObject(result: InsolesModelModel, src: InsolesModelModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.gabaritShoeSizes = this.insoleModelGabaritShoeSizeSummaryConverter.convertFromArray(src.gabaritShoeSizes);
        result.camMethods = this.lovValueSummaryConverter.convertFromArray(src.camMethods);
    }

}
